const RECORD_TIME_FORMAT = new Intl.DateTimeFormat("zh-CN", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
});

export function formatRecordTime(value: string): string {
  const trimmed = value.trim();
  const numeric = /^\d+$/.test(trimmed) ? Number(trimmed) : Number.NaN;
  const timestamp = Number.isFinite(numeric)
    ? numeric < 1_000_000_000_000
      ? numeric * 1000
      : numeric
    : trimmed;
  const date = new Date(timestamp);
  return Number.isNaN(date.getTime()) ? value : RECORD_TIME_FORMAT.format(date);
}
